import type {StateChangeActionConfig} from '@yandex-delivery/order-form/src/actions/types'
import {useCallback} from 'react'
import {useFormContext} from 'react-hook-form'

type Props = Pick<StateChangeActionConfig, 'state_diff'>

export function useStateChangeAction() {
  const {setValue} = useFormContext()

  return useCallback(
    (props: Props) => {
      const {state_diff} = props
      Object.entries(state_diff).forEach(([key, value]) => {
        setValue(key, value)
      })
    },
    [setValue],
  )
}
